<template>
  <v-container fluid>
    <v-layout row>
      <v-expansion-panel focusable>
        <v-expansion-panel-content class="mycustomExpansionPanel">
          <template v-slot:actions>
            <v-icon large color="primary">$vuetify.icons.expand</v-icon>
          </template>
          <template v-slot:header>
            <div>
              <v-icon color="primary">search</v-icon>
              <span class="pl-2 subheading">Custom Search Panel</span>
            </div>
          </template>
          <v-layout row wrap align-center>
            <v-flex>
              <v-card class="px-3">
                <v-layout row wrap align-center class="py-3">
                  <v-flex xs12>
                    <v-text-field
                      v-model="searchParam.reg_no"
                      type="number"
                      class="ma-2"
                      menu-props="auto"
                      label="Regestration Number"
                      prepend-icon="edit"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-layout justify-center row fill-height align-center>
                      <v-btn color="primary" large>
                        Search
                      </v-btn>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-layout>
    <br />
    <br />
    <!-- v-if="getProbableData.length" -->
    <v-card color="white">
      <v-layout row>
        <v-card flat>
          <v-badge left overlap>
            <template v-slot:badge>
              <v-btn
                round
                color="primary"
                fab
                small
                style="margin-top: -1.3em;"
                class="elevation-0"
              ></v-btn>
            </template>
            <v-card-text class="title"
              >Special Form Fill-up Application List</v-card-text
            >
          </v-badge>
        </v-card>
        <v-divider class="my-2" vertical></v-divider>
        <v-spacer />
        <v-btn color="primary" dark @click="apply()"
          ><v-icon dark>add</v-icon> Apply for Special Form Fill-up</v-btn
        >
      </v-layout>
    </v-card>
    <!-- :items="getProbableData" -->
    <v-layout row>
      <v-flex>
        <v-card flat>
          <v-data-table
            :headers="Listheaders"
            :items="specialFormFillUpList"
            :search="search"
            class="elevation-1"
            :rows-per-page-items="[
              25,
              50,
              100,
              { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 },
            ]"
            :pagination.sync="pagination"
          >
            <template v-slot:items="props">
              <td>{{ props.index + 1 }}</td>
              <td class="text-xs">{{ props.item.reg_no }}</td>
              <td class="text-xs">{{ props.item.std_name }}</td>
              <td class="text-xs">{{ props.item.status }}</td>
              <td class="text-xs">{{ props.item.applied_by }}</td>
              <td class="text-xs-center">
                <v-btn
                  color="primary"
                  dark
                  @click="downloadLetter(props.item.id)"
                  ><v-icon dark>add</v-icon>Download Application</v-btn
                >
              </td>
              <td class="text-xs-center">
                <v-btn color="red" dark @click="removeLetter(props.item.id)"
                  ><v-icon dark>delete_forever</v-icon>Cancle Application</v-btn
                >
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="confirmDialog" persistent max-width="400px">
      <v-card>
        <v-card-title
          class="headline"
          style="background-color: #5666BE; color: #fff;"
          >Confirm Action</v-card-title
        >

        <v-card-text style="text-align: center; font-size: large;">
          Are you sure you want to cancel this letter?
        </v-card-text>

        <v-card-actions style="text-align: center;">
          <v-spacer></v-spacer>
          <v-btn
            color="red"
            style="color: #fff;"
            small
            @click="confirmDialog = false"
          >
            No
          </v-btn>
          <v-btn
            color="indigo"
            style="color: #fff;"
            small
            @click="confirmCancelLetter"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import compulsorySubject from "@/views/collegeUserPanel/specialff/compulsory_subject";

import electiveSubject from "@/views/collegeUserPanel/specialff/elective_subject";
import StudentInfo from "@/views/collegeUserPanel/specialff/student_info";
import FormFillUpFee from "@/views/collegeUserPanel/specialff/FormFillUpFee";
import improvementSubject from "@/views/collegeUserPanel/specialff/improvement_subject";
import optionalSubject from "@/views/collegeUserPanel/specialff/optional_subject";

import commonGet from "@/mixin/common_getters_mixin";
import watchMixin from "@/mixin/exam_year_watch_mixin";

export default {
  mixins: [commonGet, watchMixin],
  components: {
    compulsorySubject,
    StudentInfo,
    FormFillUpFee,
    electiveSubject,
    improvementSubject,
    optionalSubject,
    // specialFormFillupList
  },
  data() {
    return {
      confirmDialog: false,
      selectedLetterId: null,
      getProbableData: [],
      col_code: "",
      localData: {},
      pagination: {},
      searchParam: {},
      dialog: false,
      loadData: false,
      search: "",
      reg_no: "",
      mobile: "",
      form_fill_up_id: null,
      fees: {},
      selected: {
        compulsory_subject: [],
        elective_subject: [],
        improvement_subject: [],
        optional_subject: [],
      },
      confirm_by_student: [],
      Listheaders: [
        {
          text: "SL.",
          sortable: false,
          align: "left",
          value: "id",
          width: "10",
        },
        { text: "REG. No.", value: "student.reg_no", sortable: false },
        { text: "Student Name", value: "student.name", sortable: false },
        { text: "Status", value: "", sortable: false },
        { text: "Applyed By", value: "", sortable: false },
        { text: "Documents", value: "student.mobile", sortable: false },
        { text: "Actions", align: "center", value: "actions", sortable: false },
      ],
      valid: true,
      today_date: "",
    };
  },
  computed: {
    specialFormFillUpList() {
      return this.$store.getters.getSpetialFFstudenList;
    },
  },

  created() {
    this.col_code = JSON.parse(localStorage.getItem("college-user"));
    this.localData = JSON.parse(localStorage.getItem("current-privilege"));
    this.searchStudent();
  },
  methods: {
    apply() {
      this.$router.push("/cu/special-ff-application");
    },

    searchStudent() {
      let reg_no = this.reg_no;
      let sub_code; 
      if (this.localData.degree_code == 1) {
        sub_code = this.localData.degree_group_code;
      } else {
        sub_code = this.localData.subject.subject_code;
      }
      this.$store.dispatch("getSpecialFFStudentList", {
        exam_code: this.localData.exam_master.exam_code,
        exam_year: this.localData.exam_master.exam_year,
        college_code: this.col_code.college_code,
        degree_code: this.localData.degree_code,
        degree_group_code: this.localData.degree_group_code,
        subject_code: sub_code,
      });
    },

    downloadLetter(id) {
      console.log("Tanvir! Letter", id);
      this.$store.dispatch("downloadLetterfile", id);
    },

    removeLetter(id) {
      this.selectedLetterId = id;
      this.confirmDialog = true; // open dialog
    },

    // Step 2: When user confirms
    confirmCancelLetter() {
      this.confirmDialog = false;
      if (this.selectedLetterId) {
        console.log("Tanvir! Cancel Letter", this.selectedLetterId);
        this.$store
          .dispatch("cancelLetterfile", this.selectedLetterId)
          .then((rsp) => {
            this.searchStudent();
          });
        this.selectedLetterId = null;
      }
    },
  },
  watch: {},
};
</script>
<style scoped>
table.v-table tbody td,
table.v-table tbody th {
  height: 0px;
  white-space: nowrap;
}
</style>
